import React from 'react';
import './ComponentBusy.scss';

export default function ComponentBusy()
{
    return (
        <div className='component-busy-container'>
            <div className='component-busy'>
                <div className='component-busy--spinner'>
                    <span></span>
                </div>
            </div>
        </div>
    )
}